import React, { useMemo, useState } from 'react';
import { InfoCliente, InfoPago, Productos, Voucher as VoucherBase } from './OrdenWebDetallePendiente';

/* ===== helpers (mismos que en los otros modales) ===== */
const resolveApiBase = (apiBaseProp) => {
  const fromProp = (apiBaseProp || '').trim();
  if (fromProp) return fromProp.replace(/\/+$/, '');
  const isLocal = ['localhost','127.0.0.1'].includes(window.location.hostname);
  return (isLocal ? 'http://localhost:5001' : window.location.origin).replace(/\/+$/, '');
};

const fetchJSON = async (url, opts = {}) => {
  const resp = await fetch(url, { credentials: 'include', ...opts });
  let j = null; try { j = await resp.json(); } catch {}
  if (!resp.ok || (j && j.ok === false)) {
    const msg = (j && j.msg) || resp.statusText || `HTTP ${resp.status}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.payload = j;
    throw err;
  }
  return j ?? {};
};
/* ===================================================== */

export default function OrdenWebDetalleEnProceso({ API_BASE, fileUrl, pedido, onClose, onEstadoCambiado }) {
  const base = useMemo(() => resolveApiBase(API_BASE), [API_BASE]);
  const [busy, setBusy] = useState(false);

  const marcarEntregado = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const url = `${base}/api/web/pedidos/id/${pedido.id}/estado`;
      console.log('[PATCH estado] ->', url, { estado: 'Entregado' });
      await fetchJSON(url, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: 'Entregado' }),
      });
      onEstadoCambiado(pedido.id, 'Entregado');
    } catch (e) {
      console.error('[marcarEntregado] error:', e);
      alert(e.message || 'No se pudo actualizar');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white rounded-t-2xl z-10">
          <h2 className="text-xl font-bold">Pedido #{pedido.id} (En Proceso)</h2>
          <button onClick={onClose} className="px-3 py-1.5 text-sm rounded-lg border border-gray-200">Cerrar</button>
        </div>

        <div className="p-6 space-y-4 overflow-y-auto">
          <InfoCliente p={pedido} />
          <InfoPago p={pedido} />
          <Productos p={pedido} API_BASE={base} fileUrl={fileUrl} />
          <VoucherBase p={pedido} API_BASE={base} fileUrl={fileUrl} />

          <div className="flex justify-end gap-2 pt-2">
            <button onClick={onClose} className="px-4 py-2 rounded-xl border border-gray-200">
              Cancelar
            </button>
            <button
              onClick={marcarEntregado}
              className="px-4 py-2 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
              disabled={busy}
            >
              {busy ? 'Guardando...' : 'Marcar como Entregado'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
